export function createHtmlImage() {
  var image = typeof Image !== 'undefined' ? new Image() : {};
  return image;
}
